import { IonCol, IonContent, IonGrid, IonHeader, IonItem, IonPage, IonRow, IonTitle, IonToolbar } from '@ionic/react'
import ControlAccess from './ControlAccess'

const Tramites = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle className="main-title">Trámites</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonGrid className="ion-no-padding">
          <div className="main-title-tramites">
            <h2 className="tramites-header">Iniciar</h2>
          </div>
          <IonItem lines="none" className="title-tramites" color="light">
            <span className="title-tramites">Seleccioná el trámite que deseás comenzar</span>
          </IonItem>
          <IonRow>
            <IonCol>
              <ControlAccess />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  )
}

export default Tramites
